"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GQFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_93)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_93`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.40002 0H33.6V24H-2.40002V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.40002 0H33.6V7.98597H-2.40002V0Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.40002 15.9719H33.6V24H-2.40002V15.9719Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.44208 12L-2.40002 24V0L6.44208 12Z",
					fill: "#0070C8"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.007 9.78247V12.6176C14.007 15.1158 16.5052 15.1158 16.5052 15.1158C16.5052 15.1158 19.0035 15.1158 19.0035 12.6176V9.78247H14.007Z",
					stroke: "black",
					strokeWidth: .0701754,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.1614 12.6176H16.8491L17.1298 14.4281H15.8807L16.1614 12.6176Z",
					fill: "#786145"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.7544 11.3684C17.7544 10.6807 17.193 10.3298 16.5052 10.3298C15.8175 10.3298 15.2561 10.6807 15.2561 11.3684C14.9123 11.3684 14.6316 11.6491 14.6316 11.993C14.6316 12.3369 14.9123 12.6176 15.2561 12.6176H17.7544C18.0982 12.6176 18.3789 12.3369 18.3789 11.993C18.3789 11.6491 18.0982 11.3684 17.7544 11.3684Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.7894 8.42102L13.9228 8.6526H14.1894L14.0561 8.88418L14.1894 9.10874H13.9228L13.7894 9.34032L13.6561 9.10874H13.3894L13.5228 8.88418L13.3894 8.6526H13.6561L13.7894 8.42102ZM14.8631 8.42102L14.9965 8.6526H15.2561L15.1228 8.88418L15.2561 9.10874H14.9965L14.8631 9.34032L14.7298 9.10874H14.4631L14.5965 8.88418L14.4631 8.6526H14.7298L14.8631 8.42102ZM15.9368 8.42102L16.0701 8.6526H16.3298L16.1965 8.88418L16.3298 9.10874H16.0701L15.9368 9.34032L15.8035 9.10874H15.5368L15.6701 8.88418L15.5368 8.6526H15.8035L15.9368 8.42102ZM17.0456 8.42102L17.1789 8.6526H17.4456L17.3122 8.88418L17.4456 9.10874H17.1789L17.0456 9.34032L16.9122 9.10874H16.6526L16.7789 8.88418L16.6526 8.6526H16.9122L17.0456 8.42102ZM18.1684 8.42102L18.3017 8.6526H18.5684L18.435 8.88418L18.5684 9.10874H18.3017L18.1684 9.34032L18.035 9.10874H17.7754L17.9017 8.88418L17.7754 8.6526H18.035L18.1684 8.42102ZM19.221 8.42102L19.3543 8.6526H19.614L19.4807 8.88418L19.614 9.10874H19.3543L19.221 9.34032L19.0877 9.10874H18.821L18.9543 8.88418L18.821 8.6526H19.0877L19.221 8.42102Z",
					fill: "#FFDA00",
					stroke: "black",
					strokeWidth: .0701754,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_93`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GQFlag };
